import { Palette } from '@ppwr/poker'
import * as React from 'react'
import Svg, { Rect, Path } from 'react-native-svg'
import { useResponsive } from '@/screens/new-design/hooks'

interface SettingsSVGProps {
  bgFill?: string
  iconFill?: string
}

export const SettingsSVG = ({
  bgFill = Palette['Shades/Maroon 2'],
  iconFill = Palette['Brand/Cream'],
  ...rest
}: React.ComponentProps<typeof Svg> & SettingsSVGProps) => {
  const { verticalScale } = useResponsive()

  return (
    <Svg width={verticalScale(40)} height={verticalScale(40)} viewBox="0 0 40 40" fill="none" {...rest}>
      <Rect width={40} height={40} rx={20} fill={bgFill} />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8333 13.5417C16.1785 13.5417 16.4583 13.8215 16.4583 14.1667V16.3454C17.3036 16.6109 17.9167 17.4005 17.9167 18.3334C17.9167 19.2662 17.3036 20.0558 16.4583 20.3213V25.8334C16.4583 26.1785 16.1785 26.4584 15.8333 26.4584C15.4882 26.4584 15.2083 26.1785 15.2083 25.8334V20.3213C14.3631 20.0558 13.75 19.2662 13.75 18.3334C13.75 17.4005 14.3631 16.6109 15.2083 16.3454V14.1667C15.2083 13.8215 15.4882 13.5417 15.8333 13.5417ZM15.2083 17.7821C15.0787 17.929 15 18.122 15 18.3334C15 18.5447 15.0787 18.7377 15.2083 18.8846C15.361 19.0576 15.5844 19.1667 15.8333 19.1667C16.0822 19.1667 16.3056 19.0576 16.4583 18.8846C16.588 18.7377 16.6667 18.5447 16.6667 18.3334C16.6667 18.122 16.588 17.929 16.4583 17.7821C16.3056 17.6091 16.0822 17.5 15.8333 17.5C15.5844 17.5 15.361 17.6091 15.2083 17.7821Z"
        fill={iconFill}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.1667 13.5417C24.5118 13.5417 24.7917 13.8215 24.7917 14.1667V19.6787C25.6369 19.9442 26.25 20.7338 26.25 21.6667C26.25 22.5995 25.6369 23.3892 24.7917 23.6546V25.8334C24.7917 26.1785 24.5118 26.4584 24.1667 26.4584C23.8215 26.4584 23.5417 26.1785 23.5417 25.8334V23.6546C22.6964 23.3892 22.0833 22.5995 22.0833 21.6667C22.0833 20.7338 22.6964 19.9442 23.5417 19.6787V14.1667C23.5417 13.8215 23.8215 13.5417 24.1667 13.5417ZM23.5417 21.1155C23.412 21.2624 23.3333 21.4553 23.3333 21.6667C23.3333 21.878 23.412 22.071 23.5417 22.2179C23.6944 22.3909 23.9178 22.5 24.1667 22.5C24.4156 22.5 24.639 22.3909 24.7917 22.2179C24.9213 22.071 25 21.878 25 21.6667C25 21.4553 24.9213 21.2624 24.7917 21.1155C24.639 20.9425 24.4156 20.8334 24.1667 20.8334C23.9178 20.8334 23.6944 20.9425 23.5417 21.1155Z"
        fill={iconFill}
      />
    </Svg>
  )
}
